import React, { useState } from 'react';
import { Box, TextField, IconButton, Autocomplete } from '@mui/material';
import { AddCircleOutlineOutlined } from '@mui/icons-material';

const PlusControlledSelect = ({
  label,
  name,
  value,
  options = [],
  required = false,
  error = false,
  helperText = '',
  placeholder = '',
  disabled = false,
  isLoading = false,
  handleChange = () => {},
  handleAddClick = () => {},
  minWidth = ''
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const resolvedValue =
    typeof value === 'object'
      ? value
      : options.find((opt) =>
          typeof opt === 'object' ? opt.value === value : opt === value
        ) || null;

  return (
    <Box width="100%" mt={2} minWidth={minWidth}>
    <Box display="flex" alignItems="center" gap={1}>
      <Autocomplete
        open={isOpen}
        onOpen={() => {}}
        onClose={() => setIsOpen(false)}
        options={options}
        loading={isLoading}
        disabled={disabled}
        value={resolvedValue}
        getOptionLabel={(option) => (typeof option === 'object' ? option.label : option)}
        isOptionEqualToValue={(option, val) =>
          typeof option === 'object' && typeof val === 'object'
            ? option.value === val.value
            : option === val
        }
        onChange={(e, newValue) => {
          setIsOpen(false);
          if (typeof newValue === 'object' && newValue?.isSpecial) {
            handleAddClick(label);
          } else {
            handleChange({
              target: {
                name,
                value: typeof newValue === 'object' ? newValue?.value : newValue,
              },
            });
          }
        }}
        renderOption={(props, option) => {
          const { key, ...restProps } = props;
          return (
            <li
              key={key}
              {...restProps}
              style={{
                fontStyle: option?.isSpecial ? 'italic' : 'normal',
                color: option?.isSpecial ? '#1976d2' : 'inherit',
                display: 'flex',
                alignItems: 'center',
                gap: 6,
              }}
            >
              {option?.label || option}
            </li>
          );
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            name={name}
            required={required}
            error={false}
            // helperText={helperText}
            placeholder={placeholder}
            InputProps={{
                ...params.InputProps,
                readOnly: true,
                endAdornment: null, 
            }}
            InputLabelProps={{ shrink: true }}
            sx={{
              '& .MuiInputLabel-root': {
                fontSize: '18px',
                background: 'white',
                '& .MuiFormLabel-asterisk': {
                  color: 'red',
                },
              },
              '& .MuiInputBase-root': {
                borderRadius: '8px',
                height: '40px',
                '& fieldset': {
                  borderColor: 'black',
                },
                '&:hover fieldset': {
                  borderColor: 'black',
                },
                '&.Mui-focused fieldset': {
                  borderColor: 'black',
                },
              },
            }}
          />
        )}
        fullWidth
      />

      <IconButton
        onClick={() => setIsOpen((prev) => !prev)}
        sx={{
          border: '1px solid',
          borderRadius: '8px',
          padding: '8px',
          '&:hover': {
            backgroundColor: '#F1F5F9',
          },
        }}
      >
        <AddCircleOutlineOutlined />
      </IconButton>
      </Box>
      {/* Show error/helper text below both */}
  {(error || helperText) && (
    <Box mt={0.5} ml={0.5}>
      <span style={{ color: error ? '#d32f2f' : '#6b7280', fontSize: '0.75rem' }}>
        {helperText}
      </span>
    </Box>
  )}
    </Box>
  );
};

export default PlusControlledSelect;
